module Meevo.Components.HostedPage {
    angular.module("meevo.components.hostedPage", []);
  }